import React, { useRef, useEffect } from "react";
import styles from "../FilterPanel.module.css";

interface FilterAllCheckboxProps {
  selected: string[];
  total: number;
  onToggle: (selectAll: boolean) => void;
  label?: string;
  className?: string;
}

const FilterAllCheckbox: React.FC<FilterAllCheckboxProps> = ({
  selected,
  total,
  onToggle,
  label = "All",
  className = "",
}) => {
  const checkboxRef = useRef<HTMLInputElement | null>(null);

  const isChecked = selected.length === 0 || selected.length === total;
  const isIndeterminate = selected.length > 0 && selected.length < total;

  useEffect(() => {
    if (checkboxRef.current) {
      checkboxRef.current.indeterminate = isIndeterminate;
    }
  }, [isIndeterminate]);

  return (
    <label className={`${styles.itemLabel} ${styles.itemLabelHover} ${className}`}>
      <input
        ref={checkboxRef}
        type="checkbox"
        checked={isChecked}
        onChange={(e) => onToggle(e.target.checked)}
        className={styles.checkboxAll}
      />
      <span className={styles.labelTextBold}>{label}</span>
    </label>
  );
};

export default FilterAllCheckbox;
